// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","btn__Disabled":"Button_btn__Disabled__ZIC+6","slideUp":"Button_slideUp__2WCn3","slideDown":"Button_slideDown__Dw3+G"};